import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T, delayMs: number): T {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delayMs);
        return (): void => clearTimeout(id);
    }, [value, delayMs]);
    return debounced;
}
